import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { GECKO_CONSTS, GeckoCardForm, GeckoToastService } from 'ui';
import { capitalise } from 'utilities/capitaliseString.js';
import GeckoPermissions from 'services/gecko-permissions';
import GeckoRequest from 'services/gecko-request';
import { UnsavedChangeble } from 'components/UnsavedChanges';
import GeckoStore from 'services/gecko-store';

class ProfileForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: '',
      last_name: '',
      email: '',
      tel: '',
      group_id: null,
      restrict_conversations: true,
      bio: '',
      direct_conversations_allowed: false,
      alias: '',
    };
  }

  componentDidMount() {
    const agent = this.props.agent;
    this.setState(
      {
        first_name: agent.first_name,
        last_name: agent.last_name,
        email: agent.email,
        tel: agent.tel,
        group_id: agent.group_id,
        restrict_conversations:
          agent.permissions && agent.permissions.restrict_conversations
            ? true
            : false,
        radius_user: agent.radius_user,
        bio: agent.bio || '',
        direct_conversations_allowed: agent.direct_conversations_allowed,
        alias: agent.alias || '',
      },
      this.props.clearUnsavedChanges
    );
  }

  getAgentTypeField(agent, agentType) {
    if (GeckoPermissions.memberOf('agent')) {
      return null;
    }
    let options = [];
    if (GeckoPermissions.memberOf('supervisor')) {
      this.props.groups.map((group) => {
        if (agentType !== 'admin') {
          if (group.type !== 'admin') {
            options.push({
              label: `${capitalise(group.type)}`,
              value: group.id,
            });
          }
        }
        return group;
      });
      if (options.length) {
        return {
          label: 'Agent Type:',
          key: 'group_id',
          type: GECKO_CONSTS.FIELD_TYPE_SELECT,
          options: options,
          hideWhen: () => agent.id === this.props.loggedInUser.id,
        };
      }
    } else if (GeckoPermissions.memberOf('admin')) {
      this.props.groups.map((group) => {
        options.push({
          label: `${capitalise(group.type)}`,
          value: group.id,
        });
        return group;
      });
      return {
        label: 'Agent Type:',
        key: 'group_id',
        type: GECKO_CONSTS.FIELD_TYPE_SELECT,
        options: options,
        hideWhen: () => agent.id === this.props.loggedInUser.id,
      };
    }
  }

  getRestrictedConversationsField(agent) {
    if (
      GeckoPermissions.memberOf('agent') ||
      GeckoPermissions.memberOf('supervisor')
    ) {
      return null;
    }
    return {
      label: 'Restrict Contact Visibility',
      description:
        'Enable this option to limit this agent’s access to assigned conversations or owned contacts only. In order for permission changes to take effect fully this agent will need to log out and back in.',
      key: 'restrict_conversations',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
    };
  }

  //TODO check permissions on supervisor below - currently all options available in dropdown
  agentFields() {
    const agent = this.props.agent;
    const agentType = this.props.groups.find(
      (group) => group.id === agent.group_id
    ).type;
    let agentFields = [
      {
        label: 'First Name:',
        key: 'first_name',
      },
      {
        label: 'Last Name:',
        key: 'last_name',
      },
      {
        label: 'Email:',
        key: 'email',
        disabledWhen: () => true,
      },
      {
        label: 'Telephone:',
        key: 'tel',
      },
      this.getAgentTypeField(agent, agentType),
      {
        label: 'Radius ID:',
        key: 'radius_user',
        hideWhen: () => !this.props.hasRadiusIntegration,
      },
      {
        label: 'Agent Bio',
        key: 'bio',
        description: 'Max 180 characters',
        width: '100%',
      },
      {
        label: 'Alias',
        key: 'alias',
        description:
          'Name you want to show on Live Chat (leave blank to use real name)',
        width: '100%',
      },
      {
        label: 'Allow conversations from students',
        key: 'direct_conversations_allowed',
        type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
        hideWhen: () => !GeckoStore.redux.get('appState.isSupport'),
      },
      this.getRestrictedConversationsField(agent),
    ];
    return agentFields.filter((field) => field !== null);
  }

  footerBtns() {
    return [
      {
        name: 'Cancel',
        type: 'outline-primary',
        handler: () => {
          this.cancelAgentDetailsUpdate();
        },
      },
      {
        name: 'Update Details',
        type: 'primary',
        handler: () => {
          this.updateAgentDetails();
        },
      },
    ];
  }

  cancelAgentDetailsUpdate() {
    const agent = this.props.agent;
    this.setState(
      {
        first_name: agent.first_name,
        last_name: agent.last_name,
        email: agent.email,
        tel: agent.tel,
        group_id: agent.group_id,
        restrict_conversations:
          agent.permissions && agent.permissions.restrict_conversations
            ? true
            : false,
        bio: agent.bio,
        direct_conversations_allowed: agent.direct_conversations_allowed,
        alias: agent.alias,
      },
      this.props.clearUnsavedChanges
    );
    this.props.toggleAgentEditing();
  }

  handleInputChange(key, value) {
    const newState = { ...this.state };
    if (key === 'bio' && value?.length > 180) {
      newState[key] = value.slice(0, 180);
    } else {
      newState[key] = value;
    }
    this.setState({
      first_name: newState.first_name,
      last_name: newState.last_name,
      tel: newState.tel,
      group_id: newState.group_id,
      restrict_conversations: newState.restrict_conversations,
      radius_user: newState.radius_user,
      bio: newState.bio,
      direct_conversations_allowed: newState.direct_conversations_allowed,
      alias: newState.alias,
    });
  }

  updateAgentDetails() {
    GeckoRequest.post(`/models/agents/${this.props.agent.id}`, {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      tel: this.state.tel,
      group_id: this.state.group_id,
      permissions: {
        restrict_conversations: this.state.restrict_conversations,
      },
      radius_user: this.state.radius_user,
      bio: this.state.bio,
      direct_conversations_allowed: this.state.direct_conversations_allowed,
      alias: this.state.alias,
    })
      .then((res) => {
        this.props.toggleAgentEditing();
        new GeckoToastService().success('Agent details updated');
      })
      .catch((err) => {
        new GeckoToastService().error(err);
      });
  }

  render() {
    return (
      <GeckoCardForm
        name="Agent Profile"
        fields={this.agentFields()}
        values={this.state}
        footerBtns={this.footerBtns()}
        handler={this.handleInputChange.bind(this)}
      ></GeckoCardForm>
    );
  }
}

ProfileForm.defaultProps = {};

ProfileForm.propTypes = {
  agent: PropTypes.object.isRequired,
  groups: PropTypes.array.isRequired,
  loggedInUser: PropTypes.object.isRequired,
  toggleAgentEditing: PropTypes.func.isRequired,
  hasRadiusIntegration: PropTypes.bool,
};

export default UnsavedChangeble([
  'first_name',
  'last_name',
  'tel',
  'group_id',
  'restrict_conversations',
  'bio',
  'direct_conversations_allowed',
  'alias',
])(ProfileForm);
